import React from "react";
import TopCard from "../../components/Dashboard/TopCard";
import BirthdaysThisMonth from "../../components/Dashboard/BirthdaysThisMonth";
import HireDate from "../../components/Dashboard/HireDate";
import HolidaysThisMonth from "../../components/Dashboard/HolidaysOfTheMonth";
import DashbordRightCard from "../../components/Dashboard/DashbordRightCard";
import AnnualEvaluation from "../../components/Dashboard/AnnualEvaluation";

const onboardData = {
  title: "On-boarding",
  rows: [
    {
      title: "New",
      count: 5,
    },
    {
      title: "For interview",
      count: 4,
    },
    {
      title: "Passed interview",
      count: 3,
    },
  ],
};

const credentialData = {
  title: "Credentials expiring",
  rows: [
    {
      title: "Expiring within 60 days",
      count: 5,
    },
    {
      title: "Expired",
      count: 4,
    },
    {
      title: "TB Test Expiring",
      count: 3,
    },
    {
      title: "Annual Eval Expiring",
      count: 3,
    },
    {
      title: "Annual Reassessment Expiring",
      count: 3,
    },
    {
      title: "No Physical Exam",
      count: 3,
    },
  ],
};

const updatedInfoData = {
  title: "New updated information",
  rows: [
    {
      title: "Profile",
      count: 3,
    },
    {
      title: "Pay rate Offer",
      count: 3,
    },
    {
      title: "W2",
      count: 3,
    },
    {
      title: "Direct Deposit",
      count: 3,
    },
  ],
};

function DashboardOverview() {
  return (
    <div className="flex justify-between flex-col lg:flex-row gap-8 bg-[#F7FAFC]">
      <div className="lg:w-[70%]">
        <div className="flex justify-between flex-col lg:flex-row gap-[2rem] md:gap-[1.5rem]">
          <TopCard title="Total Employees" count="56" />
          <TopCard title="Total Applicants" count="13" />
          <TopCard title="Total On-boarding" count="7" />
        </div>

        <BirthdaysThisMonth />
        <HireDate />
        <AnnualEvaluation />

        <HolidaysThisMonth />
      </div>

      <div className="lg:w-[30%]">
        <DashbordRightCard data={onboardData} />
        <DashbordRightCard data={credentialData} />
        <DashbordRightCard data={updatedInfoData} />
      </div>
    </div>
  );
}

export default DashboardOverview;
